/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

/**
* Maps one internal creative id to the external RTB creative it was deployed as.
*/
export class V3RTBCreativeMapping {
    /**
    * Internal creative ID.
    */
    'internalCreativeId'?: string;
    /**
    * External RTB creative ID.
    */
    'externalCreativeId'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "internalCreativeId",
            "baseName": "internal_creative_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "externalCreativeId",
            "baseName": "external_creative_id",
            "type": "string",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V3RTBCreativeMapping.attributeTypeMap;
    }

    public constructor() {
    }
}

